import styles from "./InfoTile.module.css";

function InfoTile({ children, label, value }) {
	return (
		<div className={styles.infoContainer}>
			<span className={styles.infoLabel}>{label}:</span>
			{!children && <span className={styles.infoValue}>{value}</span>}
            {children}
		</div>
	);
}

export default InfoTile;
